import * as actionTypes from "./actionTypes";
// import { attributes } from "../../data";
import { firebase } from "../../firebase/index";
import {
  collections,
  constants,
  documents,
} from "../../firebase/firestoreNameSpaces";
import { generateUniqueId, uploadImage, deleteFileFromUrl } from "../utility";
const checkAttributeExist = (attributes, name) => {
  return attributes.filter(
    (obj) => obj.name.toLowerCase().trim() == name.toLowerCase().trim()
  ).length;
};
const checkAttributeValueExist = (values, attrValue) => {
  values = values.map((v) => v.trim().toLowerCase());
  return values.includes(attrValue.toLowerCase().trim());
};

export const fetchAttribute = () => {
  return (dispatch) => {
    try {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { loading: true },
      });
      let db = firebase.firestore();
      db.collection(collections.K5METADATA)
        .doc(documents.ATTRIBUTES)
        .onSnapshot((snapshot) => {
          let attributes = [];
          let data = snapshot.data();
          for (let ak in data) {
            attributes.push(data[ak]);
          }
          dispatch({
            type: actionTypes.ATTRIBUTE_CONTROLS,
            payload: { attribute: attributes, loading: false },
          });
        });
    } catch (error) {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { attribute: null, loading: false },
      });
      return alert(error);
    }
  };
};
export const onAddAttribute = (attribute) => {
  return async (dispatch, getState) => {
    let attributes = getState().attributes.attribute;
    let { id, name } = attribute;
    try {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { loading: true, editAttributeBtnLoading: true },
      });

      if (checkAttributeExist(attributes, name)) {
        dispatch({
          type: actionTypes.ATTRIBUTE_CONTROLS,
          payload: { loading: false, editAttributeBtnLoading: false },
        });
        return alert("Please Enter a different Name");
      }
      //##############
      let db = firebase.firestore();

      await db
        .collection(collections.K5METADATA)
        .doc(documents.ATTRIBUTES)
        .set(
          { [id]: { id: id, name: name.toLowerCase().trim() } },
          { merge: true }
        );
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { loading: false, editAttributeBtnLoading: false },
      });
      return alert(`${name} Added Successfully`);
    } catch (error) {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { loading: false, editAttributeBtnLoading: false },
      });
      return alert(error);
    }
  };
};

export const onAttributeRename = (attribute) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { editAttributeNameLoading: true },
      });

      let attributes = getState().attributes.attribute;
      let { id, name } = attribute;
      let newattributename = name.toLowerCase();
      let attributeId = id;

      //###########
      if (checkAttributeExist(attributes, newattributename)) {
        dispatch({
          type: actionTypes.ATTRIBUTE_CONTROLS,
          payload: { editAttributeNameLoading: false },
        });
        return alert("Please Enter a different Name");
      }
      let db = firebase.firestore();
      await db
        .collection(collections.K5METADATA)
        .doc(documents.ATTRIBUTES)
        .set(
          { [attributeId]: { name: newattributename, id: attributeId } },
          { merge: true }
        );
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { editAttributeNameLoading: false },
      });
      return alert("Attribute Renamed Successfully");
    } catch (error) {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { editAttributeNameLoading: false },
      });
      return alert(error);
    }
  };
};

export const onDeleteAttribute = (attributeId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { delAttributeBtnLoading: true },
      });

      let db = firebase.firestore();
      document.getElementById(`d${attributeId}`).click();
      await db
        .collection(collections.K5METADATA)
        .doc(documents.ATTRIBUTES)
        .set(
          { [attributeId]: firebase.firestore.FieldValue.delete() },
          { merge: true }
        );
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { delAttributeBtnLoading: false },
      });
      return alert("Attribute Deleted Successfully");
    } catch (error) {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { delAttributeBtnLoading: false },
      });
      return alert(error);
    }
  };
};

export const onValueRename = (newValue, attribute) => {
  let { id, subCategoryName, oldSubCategoryName } = newValue;
  // return console.log(id, subCategoryName, oldSubCategoryName, attributeValues);

  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { editValueLoading: true },
      });

      let attrId = id;
      let attrValue = subCategoryName.toLowerCase();

      //############
      if (attribute.values) {
        if (checkAttributeValueExist(attribute.values, attrValue)) {
          dispatch({
            type: actionTypes.ATTRIBUTE_CONTROLS,
            payload: { editValueLoading: false },
          });
          return alert("Please Enter Differnent Value");
        }
      }

      let db = firebase.firestore();
      let attrRef = db
        .collection(collections.K5METADATA)
        .doc(documents.ATTRIBUTES);
      await attrRef.set(
        {
          [attrId]: {
            values: firebase.firestore.FieldValue.arrayUnion(attrValue),
          },
        },
        { merge: true }
      );
      await attrRef.set(
        {
          [attrId]: {
            values:
              firebase.firestore.FieldValue.arrayRemove(oldSubCategoryName),
          },
        },
        { merge: true }
      );
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { editValueLoading: false },
      });
      return alert(attrValue + " Renamed Succssfully");
    } catch (error) {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { editValueLoading: false },
      });
      return alert(error);
    }
  };
};

export const onDeleteValue = (attributeId, value) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { delValueBtnLoading: true },
      });
      let attrId = attributeId;
      let attrValue = value;
      //###############
      document.getElementById(`cd${attrId}${value}`).click();
      let db = firebase.firestore();
      await db
        .collection(collections.K5METADATA)
        .doc(documents.ATTRIBUTES)
        .set(
          {
            [attrId]: {
              values: firebase.firestore.FieldValue.arrayRemove(attrValue),
            },
          },
          { merge: true }
        );
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { delValueBtnLoading: false },
      });
      return alert(attrValue + " Deleted Successfully");
    } catch (error) {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { delValueBtnLoading: false },
      });
      return alert(error);
    }
  };
};

export const onAddValue = (value, attribute) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { addValueBtnLoading: true },
      });

      let attrId = attribute.id;
      let attrValue = value.newValueName.toLowerCase().trim();
      //############
      if (attribute.values) {
        if (checkAttributeValueExist(attribute.values, attrValue)) {
          dispatch({
            type: actionTypes.ATTRIBUTE_CONTROLS,
            payload: { addValueBtnLoading: false },
          });
          return alert("Please Enter Differnent Value");
        }
      }

      let db = firebase.firestore();
      await db
        .collection(collections.K5METADATA)
        .doc(documents.ATTRIBUTES)
        .set(
          {
            [attrId]: {
              values: firebase.firestore.FieldValue.arrayUnion(attrValue),
            },
          },
          { merge: true }
        );
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { addValueBtnLoading: false },
      });
      return alert(attrValue + " Added Succssfully");
    } catch (error) {
      dispatch({
        type: actionTypes.ATTRIBUTE_CONTROLS,
        payload: { addValueBtnLoading: false },
      });
      return alert(error);
    }
  };
};
